import React from 'react';
import {
    Box,
    Tooltip,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Avatar
} from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import PersonIcon from '@mui/icons-material/Person';
import { grey } from '@mui/material/colors';
import Popover from './Popover';
import {
    Logout,
    Security,
    KeyboardArrowDown
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function Navbar({ username, handlerLogout, admin }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSecurity = () => {
        handleClose();
        navigate('/admin/profile/security');
    };

    const handleLogout = () => {
        handleClose();
        handlerLogout();
    };

    // Pegar iniciais do nome
    const getInitials = (name) => {
        if (!name) return 'U';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name[0].toUpperCase();
    };

    return (
        <>
            {/* Botao do usuario com dropdown */}
            <Box
                onClick={handleClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '4px 8px',
                    borderRadius: 1,
                    '&:hover': {
                        backgroundColor: 'rgba(255,255,255,0.1)'
                    }
                }}
            >
                <Avatar
                    sx={{
                        width: 32,
                        height: 32,
                        bgcolor: grey[700],
                        fontSize: 14,
                        mr: 1
                    }}
                >
                    {getInitials(username)}
                </Avatar>
                <Typography sx={{ color: grey[100], mr: 0.5 }}>
                    {username}
                </Typography>
                <KeyboardArrowDown
                    sx={{
                        color: grey[100],
                        fontSize: 20,
                        transition: 'transform 0.2s',
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}
                />
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        minWidth: 200,
                        mt: 1,
                        '& .MuiMenuItem-root': {
                            py: 1.5
                        }
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {admin && (
                    <MenuItem onClick={handleSecurity}>
                        <ListItemIcon>
                            <Security fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Seguranca</ListItemText>
                    </MenuItem>
                )}

                {admin && <Divider />}

                <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
                    <ListItemIcon>
                        <Logout fontSize="small" sx={{ color: 'error.main' }} />
                    </ListItemIcon>
                    <ListItemText>Sair</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}

function ServicesPopper() {
    const navigate = useNavigate();
    return (
        <Popover name="Servicos" icon={<AppsIcon sx={{ color: grey[100] }} />}>
            <Box>
                <Tooltip title="Provisionamento">
                    <IconButton
                        onClick={() => navigate('/provisioning/dashboard')}
                    >
                        <PersonIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Popover>
    );
}
